<div class="title mb-4">
  <h2>Forum Giveaway Survey</h2>
</div>

<div class="row">
  <div class="col-lg-12 col-md-12">
    <div class="white_box shadow p-3">
      <form>
        <div class="mb-3 row">
          <!-- <label for="table-filtering-search" class="col-xs-3 col-sm-auto col-form-label">Full text search:</label> -->
          <div class="col-xs-3 col-sm-auto">
            <button type="button" [routerLink]="['/admin/forum-giveaway']" class="btn btn-light btn-sm mb-2"><i class="fa-solid fa-arrow-left"></i> Back</button>
          </div>
        </div>
      </form>

      <!-- Table -->
      <section>
        <div class="table-responsive">
          <table class="table">
            <tr>
              <th width="10%">Images</th>

              <td>
                <ng-container *ngFor="let image of giveaway.images">
                  <img loading="lazy" src="{{ imgUrl }}{{ image }}" class="img-thumbnail mr-2" style="height: 50px" alt="" />
                </ng-container>
              </td>
            </tr>
            <tr>
              <th width="10%">Description</th>

              <td>
                <div [innerHTML]="giveaway?.description"></div>
              </td>
            </tr>

            <tr>
              <th width="10%">End Date</th>

              <td>
                <div [innerHTML]="giveaway?.endDate"></div>
              </td>
            </tr>
          </table>
        </div>
        <div class="my-3" *ngIf="survey.data?.status == 0">
          <button type="button" class="btn btn-success btn-sm w-100" (click)="survey.openForm = !survey.openForm"><i class="fa-solid fa-plus"></i> Create New Survey</button>
          <div class="card text-left mt-2" *ngIf="survey.openForm">
            <div class="card-body">
              <div class="form-group">
                <label for="">Question?</label>
                <textarea name="" [(ngModel)]="survey.question" id="" class="form-control"></textarea>
              </div>
              <div class="form-group">
                <label for="">
                  Answer!
                  <button class="btn btn-sm btn-primary" (click)="survey.answer.push('')">
                    <i class="fa-solid fa-plus"></i>
                  </button>
                </label>
                <ng-container *ngFor="let answer of survey.answer; let index = index">
                  <div class="d-flex mb-2" style="gap: 7px">
                    <input type="text" class="form-control" [value]="answer" (change)="putAnswer($event.target.value, index)" placeholder="Answer {{ index + 1 }}" />
                    <button class="btn btn-sm btn-danger" (click)="removeAnswer(index)">
                      <i class="fa-solid fa-trash"></i>
                    </button>
                  </div>
                </ng-container>
              </div>
              <button class="btn btn-warning" (click)="storeSurvey()"><i class="fa-solid fa-save"></i> Save</button>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <h5 class="mb-0"><i class="fa-solid fa-question"></i> Questions</h5>
          </div>
          <div class="card-body">
            <ng-container *ngIf="survey.data?.giveawaySurveyQuestions.length < 1">
              <h1 class="text-center"><i class="fa-solid fa-search-minus"></i> There is no survey yet.</h1>
            </ng-container>
            <ng-container *ngIf="survey.data?.giveawaySurveyQuestions.length > 0">
              <div class="accordion" id="accordionExample">
                <div class="card" *ngFor="let item of survey.data.giveawaySurveyQuestions; let i = index">
                  <div class="card-header d-flex justify-content-between" id="heading_{{ i }}">
                    <h2 class="mb-0">
                      <button class="btn btn-link btn-block text-left text-dark" type="button" (click)="toggleAccordion(i)" aria-expanded="{{ i === activeIndex }}" aria-controls="collapse_{{ i }}">
                        {{ item.question }}
                      </button>
                    </h2>
                    <button class="btn btn-sm btn-danger" *ngIf="survey.data?.status == 0" (click)="deleteGiveaway(item.id)">
                      <i class="fa-solid fa-trash"></i>
                    </button>
                    <div class="my-auto" *ngIf="survey.data?.status == 1">
                      <span class="badge badge-success my-auto"> <i class="fa-solid fa-paper-plane"></i> Published </span>
                    </div>
                  </div>

                  <div id="collapse_{{ i }}" class="collapse" [ngClass]="{ show: i === activeIndex }" aria-labelledby="heading_{{ i }}" data-parent="#accordionExample">
                    <div class="card-body">
                      <div class="btn-group mb-3">
                        <button class="btn btn-{{ item.showParticipant ? 'light' : 'primary' }}" (click)="item.showParticipant = false">Answer List</button>
                        <button class="btn btn-{{ !item.showParticipant ? 'light' : 'primary' }}" (click)="item.showParticipant = true">Participants ({{ item.giveawaySurveyParticipants.length }})</button>
                      </div>
                      <table class="table table-bordered table-striped" *ngIf="!item.showParticipant">
                        <tr *ngFor="let answer of item.answer; let index = index">
                          <td width="5%">{{ index + 1 }}</td>
                          <td>{{ answer }}</td>
                        </tr>
                      </table>
                      <table class="table table-bordered table-striped" *ngIf="item.showParticipant">
                        <tr>
                          <th>No</th>
                          <th>Username</th>
                          <th>Answer</th>
                        </tr>
                        <tr *ngFor="let participant of item.giveawaySurveyParticipants; let index = index">
                          <td width="5%">{{ index + 1 }}</td>
                          <td>{{ participant?.appUser?.profileCharacterName ?? "Unknown" }}</td>
                          <td>{{ participant.answer }}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-3" *ngIf="survey.data?.status == 0">
                <button class="btn btn-success" (click)="publishSurvey()"><i class="fa-solid fa-paper-plane"></i> Publish Survey</button>
              </div>
            </ng-container>
          </div>
        </div>
      </section>
      <!-- Table -->
    </div>
  </div>
</div>
